module.exports = __webpack_public_path__ + "static/media/19ESCAP11.82dc49a7.jpg";